import { HTTPServiceClient } from '@/packages/http/service';
import * as endpoint from './endpoints';
import { FetchRootInvestmentsRequest, PensionScheme } from './types';
/**
 * --------------------------------------------------
 *	AssetOwner HTTP Service
 * --------------------------------------------------
 **/
export const AssetOwnerService = {
  async fetchRootInvestments(
    request: FetchRootInvestmentsRequest
  ): Promise<PensionScheme[]> {
    const { data: rootInvestmentData } = await HTTPServiceClient.get(
      endpoint.GET_ENTITY_ROOT_INVESTMENTS({
        ...request,
        page: 1,
        limit: 1,
        addTimePeriod: false,
        addChildren: false,
        addEntityRootInvestments: true
      })
    );
    if (!rootInvestmentData.data.length) {
      return [];
    }
    const investmentIds = rootInvestmentData.data[0].entity.rootInvestements.data.map(
      (rootInvestment: PensionScheme) => rootInvestment.id
    );
    const { data } = await HTTPServiceClient.get(
      endpoint.GET_ENTITY_ROOT_INVESTMENTS({
        ...request,
        page: 1,
        limit: investmentIds.length,
        investmentIds,
        addTimePeriod: true,
        addChildren: true,
        addEntityRootInvestments: false
      })
    );
    return data.data;
  }
};
